import * as React from 'react'

interface IUseGlobalSearchQueryStateResult {
  query: string
  submittedQuery: string
  setSubmittedQuery: React.Dispatch<React.SetStateAction<string>>
  setQuery: (value: string) => void
  inputRef: React.RefObject<HTMLInputElement>
}

export const useGlobalSearchQueryState =
  (): IUseGlobalSearchQueryStateResult => {
    const [query, setQueryState] = React.useState('')
    const [submittedQuery, setSubmittedQuery] = React.useState('')
    const inputRef = React.useRef<HTMLInputElement>(null)

    const setQuery = React.useCallback((value: string) => {
      setQueryState(value)
      if (value === '') {
        setSubmittedQuery('')
      }
    }, [])

    return {
      query,
      submittedQuery,
      setSubmittedQuery,
      setQuery,
      inputRef,
    }
  }
